/* eslint-disable react/prop-types */
import { Navigate, Outlet } from 'react-router-dom'
import { withRouter } from '../../../withRouter'
import { TabBar } from '../../../components/generic'
import { FC } from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import { RotaPaywallScreen } from './RotaPaywallScreen'
import { TabBarItem } from 'components/generic/TabBar/TabBar'

type NavItem = {
  url: string
  label: string
}

const RotaRouteScreen: FC<{ location: any; router: any }> = ({
  location,
  router,
}) => {
  const flags = useFeatureFlags({
    flagNames: ['published_rota'],
  })?.data

  const { hasRota } = useHomeType()

  const flagsPublishedRotaEnabled = flags?.published_rota?.enabled

  let items: NavItem[] = []

  if (!hasRota) {
    items = []
  } else {
    items = flagsPublishedRotaEnabled
      ? NAV_TABS_WITH_PUBLISHED
      : NAV_TABS_WITH_MONITORING
  }

  return (
    <div>
      <TabBar
        // @ts-ignore
        items={items}
        resourceUrl="rota"
        location={location}
      />
      <Outlet />
      {hasRota ? (
        router.location.pathname === '/rota' && <Navigate to="builder" />
      ) : (
        <RotaPaywallScreen />
      )}
    </div>
  )
}

export default withRouter(RotaRouteScreen)

const NAV_TABS_WITH_MONITORING = [
  {
    url: 'monitoring',
    label: 'Monitoring',
  },
  {
    url: 'builder',
    label: 'Rota Builder',
  },
  {
    url: 'patterns',
    label: 'Manage Patterns',
  },
]

const NAV_TABS_WITH_PUBLISHED: TabBarItem[] = [
  {
    url: 'published',
    label: 'Published',
    search: () => window.location.search,
  },
  {
    url: 'monitoring',
    label: 'Monitoring',
  },
  {
    url: 'builder',
    label: 'Builder',
    search: () => window.location.search,
  },
  {
    url: 'patterns',
    label: 'Manage Patterns',
  },
]
